import * as React from 'react';
import { PwaHsrPropertyDestinationRefinement } from 'src/common/__generated__/api';

export interface DestinationRefinementImageAttributionProps {
  attribution: PwaHsrPropertyDestinationRefinement.Attribution;
}

export const DestinationRefinementImageAttribution: React.FunctionComponent<DestinationRefinementImageAttributionProps> = ({
  attribution
}) => <div className={'uitk-cell uitk-type-200'}>{attribution.label}</div>;
